import React from 'react'

import { TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, number, oneOfType, arrayOf, shape,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import MetaTag from './MetaTag'
import { buildRendererLabel } from './Utils/buildRendererLabel'
import { getBaseTagClasses } from './Utils/getBaseTagClasses'

const buildVersionParts = (fileVersion) => {
  const rendererParts = [
    fileVersion.rendererName,
    fileVersion.rendererVersion,
  ].filter(Boolean)

  const versionParts = []

  if (rendererParts.length > 0) {
    versionParts.push(rendererParts.join(' '))
  }

  if (fileVersion.version) {
    versionParts.push(fileVersion.version)
  }

  return versionParts
}

function ExpandedFormat({
  title,
  extensionPath,
  fileSize,
  version,
  rendererName,
  rendererVersion,
  itemFileVersions = EMPTY_ARRAY,
  fileCount,
  index,
}) {
  const hasMultipleFiles = fileCount > 1
  const versionTags = hasMultipleFiles
    ? itemFileVersions
        .map(fileVersion => buildVersionParts(fileVersion))
        .filter(parts => parts.length > 0)
    : []

  const rendererLabel = buildRendererLabel({ rendererName, rendererVersion })
  const versionLabel = [rendererLabel, version].filter(Boolean).join(' | ')

  return (
    <div key={`expanded-format-${index}`} className="details-area__format-item">
      <div className="details-area__format-item-row">
        <TagComponent
          color="primary"
          hasBorder
          className={getBaseTagClasses(
            'details-area__format-tag--primary',
            !extensionPath && 'details-area__tag--no-clickable',
            extensionPath && 'details-area__tag--link',
          )}
          href={extensionPath}
        >
          <span className="details-area__format-tag-title">
            {title}
          </span>
          {hasMultipleFiles && (
            <>
              <span aria-hidden="true" className="details-area__format-tag-separator">|</span>
              <span className="details-area__format-tag-files">
                {fileCount} files
              </span>
            </>
          )}
        </TagComponent>

        {fileSize && (
          <MetaTag>{`Size: ${fileSize}`}</MetaTag>
        )}

        {!hasMultipleFiles && versionLabel && (
          <MetaTag>{versionLabel}</MetaTag>
        )}
      </div>

      {versionTags.length > 0 && (
        <div className="details-area__format-item-row">
          {versionTags.map((versionParts, versionIndex) => (
            <MetaTag
              key={`expanded-format-details-${index}-${versionIndex}`}
              additionalClassName="details-area__format-tag--meta-detail"
            >
              {versionParts.join(' | ')}
            </MetaTag>
          ))}
        </div>
      )}
    </div>
  )
}

ExpandedFormat.propTypes = {
  title: string.isRequired,
  extensionPath: string,
  fileSize: string.isRequired,
  fileCount: number.isRequired,
  version: string,
  rendererName: string,
  rendererVersion: oneOfType([string, number]),
  itemFileVersions: arrayOf(shape({
    version: oneOfType([string, number]),
    rendererName: string,
    rendererVersion: oneOfType([string, number]),
  })),
  index: number.isRequired,
}

export default ExpandedFormat
